export const MIN_ACCESS_AFTER_TERMINATION_DAYS = 0;
export const MAX_ACCESS_AFTER_TERMINATION_DAYS = 180;

export function clampAccessAfterTerminationDays(value: any): number {
    const parsed = typeof value === "number" ? value : parseInt(value, 10);

    if (isNaN(parsed) || !isFinite(parsed)) {
        return MIN_ACCESS_AFTER_TERMINATION_DAYS;
    }

    const whole_parsed_number = Math.floor(parsed);
    
    return Math.max(
        MIN_ACCESS_AFTER_TERMINATION_DAYS,
        Math.min(MAX_ACCESS_AFTER_TERMINATION_DAYS, whole_parsed_number)
    );
}